import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { formatGameTime } from "../format/formatGameTime";
import { formatList } from "../format/formatList";
import { AssetList } from "./AssetList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";

const TITLE = msg({
  id: "finding.off_build_early",
  message: "{count, plural, one {# item} other {# items}} bought before the core build",
});

const DETAILS = msg({
  id: "finding.off_build_early.details",
  message:
    "Strong players on this hero buy these rarely or much later. Core items you did not have yet: {missing}.",
});

const SUMMARY = msg({
  id: "finding.off_build_early.summary",
  message: "Core items still missing: {missing}",
});

// Предметы не по порядку сильных игроков, пока база не собрана.
export const OffBuildEarly = ({ finding, variant }: FindingProps<"off_build_early">) => {
  const { i18n } = useLingui();
  const findItem = useAssetLookup("items");
  const { purchases, missing_core_item_ids: missingIds } = finding.params;
  const missing = formatList(
    missingIds.map((id) => findItem(id).name),
    i18n.locale,
  );
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<AssetIcon asset={findItem(purchases[0]?.item_id ?? 0)} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { count: purchases.length } })}
      details={i18n._({ ...DETAILS, values: { missing } })}
      summary={i18n._({ ...SUMMARY, values: { missing } })}
    >
      <AssetList
        entries={purchases.map((purchase) => ({
          asset: findItem(purchase.item_id),
          caption: formatGameTime(purchase.bought_at_s),
        }))}
      />
    </FindingCard>
  );
};
